import * as types from '../../actions/actiontypes';

export default function userSearchReducerGA(state = {}, action) {
	switch (action.type) {
		case types.GET_USER_SEARCH_GA: {
			return action.response == undefined ? null : action.response;
		}
		default:
			return state;
	}
}
